import { render, staticRenderFns } from "./mine_comment.vue?vue&type=template&id=607234df&lang=pug&"
import script from "./mine_comment.vue?vue&type=script&lang=js&"
export * from "./mine_comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports